import { Divider, Typography } from 'antd';
import { motion } from 'framer-motion';
import React from 'react';
import ThemeSettings from '../../components/ThemeSettings';
import { pageVariants } from '../../constants';
import NotificationSound from '../../components/NotificationSound';

const SettingScreen = () => {

    return (
        <motion.div
            className="Settings"
            initial="hidden"
            animate="visible"
            exit="hidden"
            variants={pageVariants}
        >
            <div className="header-flex">
                <div className="page-title">Settings</div>
            </div>

            <div className="theme-bg shadow p-6">
                {/* Notification */}
                <Typography.Title level={5}>Notification</Typography.Title>
                <NotificationSound />
                <Divider />

                {/* Theme */}
                <Typography.Title level={5}>Theme</Typography.Title>
                <ThemeSettings />
                <Divider />
            </div>
        </motion.div>
    );
};

export default SettingScreen;
